module.exports = __webpack_public_path__ + "img/logo.c5f65eb1.png";